/* Vertical scenes: no slide timer, swipe navigation or hidden product stories. */
(() => {
  'use strict';
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  const controllers = new Map();
  function initialize(root) {
    const eggs = [...root.querySelectorAll('[data-mx-egg]')];
    if (root.matches?.('[data-mx-egg]')) eggs.unshift(root);
    eggs.forEach(egg => {
      if (controllers.has(egg)) return;
      const button = egg.querySelector('[data-mx-open]');
      let seen = false, timer;
      const setOpen = open => {
        egg.classList.toggle('is-open', open);
        button.setAttribute('aria-expanded', String(open));
        button.textContent = open ? 'Cerrar el huevo ↙' : 'Abrir el huevo ↗';
      };
      const click = () => { seen = true; clearTimeout(timer); setOpen(!egg.classList.contains('is-open')); };
      const motion = () => { clearTimeout(timer); if (reduced.matches) setOpen(true); };
      button.addEventListener('click', click);
      reduced.addEventListener('change', motion);
      const observer = new IntersectionObserver(entries => {
        if (!seen && entries.some(e => e.isIntersecting)) {
          seen = true;
          if (reduced.matches) setOpen(true);
          else timer = setTimeout(() => setOpen(true), 450);
          observer.disconnect();
        }
      }, {threshold:0.5});
      observer.observe(egg);
      if (reduced.matches) setOpen(true);
      controllers.set(egg, () => { clearTimeout(timer); observer.disconnect(); button.removeEventListener('click', click); reduced.removeEventListener('change', motion); controllers.delete(egg); });
    });
  }
  initialize(document);
  document.addEventListener('shopify:section:load', e => initialize(e.target));
  document.addEventListener('shopify:section:unload', e => { for (const [egg, cleanup] of controllers) if (e.target.contains(egg)) cleanup(); });
  let queued = false;
  function updateHeader() {
    queued = false;
    const header = document.querySelector('.section-header');
    let offset = 0;
    if (header) {
      const rect = header.getBoundingClientRect(), position = getComputedStyle(header).position;
      if (position === 'sticky' || position === 'fixed') offset = Math.max(0, Math.min(rect.bottom, rect.height));
    }
    document.documentElement.style.setProperty('--mx-header-offset', `${Math.ceil(offset)}px`);
  }
  const queue = () => { if (!queued) { queued = true; requestAnimationFrame(updateHeader); } };
  addEventListener('scroll',queue,{passive:true}); addEventListener('resize',queue,{passive:true});
  const header = document.querySelector('.section-header');
  if (header) { new ResizeObserver(queue).observe(header); new MutationObserver(queue).observe(header,{attributes:true,attributeFilter:['class']}); }
  updateHeader();
})();
